module.exports = __webpack_public_path__ + "static/thpcfarm2-65fa3a80a8177f42df17f75a01ee31f1.jpeg";